<template>
  <div style="padding-bottom:15px;">
    <div class="w3-padding w3-form-container">
      <input class="w3-input w3-border w3-margin-bottom" v-model="contact.email" placeholder="Email" />
      <input class="w3-input w3-border w3-margin-bottom" v-model="contact.subject" placeholder="Subject" />
      <textarea class="w3-input w3-border w3-margin-bottom" rows="3" v-model="contact.message" placeholder="Enter your message" />
      <template v-if="submitError !== ''">
        <p style="color:#c62828; text-align:center;">{{submitError}}</p>
      </template>
      <template v-if="submitSuccess">
        <p style="color:#43a047; text-align:center;">Successfully sent message</p>
      </template>
      <div class="w3-row">
        <div class="w3-col s6">
          <button class="w3-button w3-block w3-red" @click="clearForm()">Clear Form</button>
        </div>
        <div class="w3-col s6">
          <button class="w3-button w3-block w3-green" @click="sendMessage()" :disabled="contact.email === '' || contact.subject === '' || contact.message === ''">Submit</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var dataStore = require("../dataStore").default;

export default {
  name: "Contact",
  data() {
    return {
      state: dataStore.state,
      contact: {
        email: '',
        subject: '',
        message: ''
      },
      submitError: '',
      submitSuccess: ''
    };
  },
  methods: {
    sendMessage() {
      this.submitError = ''
      if (this.contact.email === '') {
        this.submitError = 'Please enter an Email Address'
        return
      }
      if (/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(this.contact.email)) {
        // ok email
        console.log('email ok')
      } else {
        this.submitError = 'Please enter a valid Email Address'
        return
      }
      if (this.contact.subject === '') {
        this.submitError = 'Please enter a Subject'
        return
      }
      if (this.contact.message === '') {
        this.submitError = 'Please enter a Message'
        return
      }
      dataStore.sendEmail(this.contact).then((response) => {
        this.submitSuccess = true
        setTimeout(() => {
          this.submitSuccess = false
        }, 15000);
      })
    },
    clearForm() {
      this.submitError = ''
      this.submitSuccess = ''
      this.contact = {
        email: '',
        subject: '',
        message: ''
      }
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue